module.exports = __webpack_public_path__ + "static/media/newWhatsapp.88c3d803.svg";